import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { showPreBudgetUnitDetails } from "Requests/Partners/PreBudgets";
import { MaskCPF } from "Utils/Masks";

export const useViewDetails = () => {
  const [modals, setModals] = useState({
    cancelOrderModal: false,
    cancelPreOrderModal: false,
    schedule: false,
  });

  const { id } = useParams<{ id: string }>();

  const preOderDetailsAPI = useQuery({
    queryFn: () => showPreBudgetUnitDetails(Number(id)),
    queryKey: ["pre-order-detail-unit", id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const getGenders = (patientGender?: string) => {
    switch (patientGender?.toLowerCase()) {
      case "m":
        return "Masculino";
      case "f":
        return "Feminino";
      default:
        return "Indefinido";
    }
  };

  const openModalSecondary = (
    modal: "schedule" | "cancelOrderModal" | "cancelPreOrderModal"
  ) => {
    const state = {
      cancelOrderModal: false,
      cancelPreOrderModal: false,
      schedule: false,
      [modal]: true,
    };
    setModals(state);
  };

  const closeSecondaryModal = () => {
    const state = {
      cancelOrderModal: false,
      cancelPreOrderModal: false,
      schedule: false,
    };
    setModals(state);
  };

  const {
    status,
    appointment_at,
    client,
    full_name,
    phone,
    ddi,
    ddd,
    gender,
    address,
    document,
    observation,
    created_at,
    products,
    have_health_insurance,
    health_insurance_card_number,
  } = preOderDetailsAPI.data ?? {};

  let dateSchedule = "";
  let timeSchedule = "";
  let preOrderCreateDate = "";
  const phoneSliced = `${phone?.slice(0, -4)}-${phone?.slice(-4)}`;

  if (appointment_at) {
    const [date, time] = appointment_at?.split(" ") || [];
    const [yyyy, mm, dd] = date?.split("-");
    timeSchedule = time?.slice(0, 5);
    dateSchedule = `${dd}/${mm}/${yyyy}`;
  }

  if (created_at) {
    const [date] = created_at?.split(" ") || [];
    const [yyyy, mm, dd] = date?.split("-");
    preOrderCreateDate = `${dd}/${mm}/${yyyy}`;
  }

  const preOrderDetails = [
    { name: "Data do agendamento", value: [dateSchedule] },
    {
      name: "Hórário do agendamento",
      value: [timeSchedule],
    },
    { name: "Status", value: [status?.status || ""] },
    {
      name: "Data de criação do pré-orçamento",
      value: [preOrderCreateDate || ""],
    },

    { name: "Observações", value: [observation || ""] },
  ];

  const preOrderAddressDetails = [
    { name: "Rua", value: [address?.street || ""] },
    {
      name: "Número",
      value: [address?.number || ""],
    },
    { name: "Bairro", value: [address?.neighborhood || ""] },
    { name: "Complemento", value: [address?.complement || ""] },
    { name: "CEP", value: [address?.zipcode || ""] },
    { name: "Cidade", value: [address?.city || ""] },
    { name: "Estado", value: [address?.state || ""] },
  ];

  const preOrderPatientDetails = [
    { name: "Nome", value: [full_name || ""] },
    {
      name: "CPF",
      value: [MaskCPF(document) || ""],
    },
    {
      name: "Telefone",
      value: [ddi ? `+${ddi.replace("+", "")} ${ddd} ${phoneSliced}` : ""],
    },
    { name: "Gênero Biológico", value: [getGenders(gender)] },
    { name: "Convênio", value: [client?.name || ""] },
    { name: "Plano", value: [have_health_insurance || ""] },
    { name: "Carteirinha", value: [health_insurance_card_number || ""] },
  ];

  return {
    preOderDetailsAPI,
    preOrderDetails,
    modals,
    openModalSecondary,
    closeSecondaryModal,
    preBudgetId: id,
    preOrderAddressDetails,
    preOrderPatientDetails,
  };
};
